import * as action_types from './action_types';
import { console_log } from "../utils/helper";

export const authenticate = (data) => {
    return {
        type: action_types.LOGIN,
        data: data
    }
};

export const logout = (data) => {
    return {
        type: action_types.LOGOUT,
        data: data
    }
};


// WEBPACK FOOTER //
// ./src/actions/AuthenticationActions.js